<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>기상안내</h3>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row mb-5" style="font-size: large;">                                
                                <div class="col-lg-12">
                                    <div class="col-lg-4 btn btn-outline-default p-20 m-0" @click="selectedTab('option1')">기상청 날씨정보</div>
                                    <div class="col-lg-4 btn btn-outline-warning p-20 m-0" @click="selectedTab('option2')">IMOC 파도정보</div>
                                    <div class="col-lg-4 btn btn-outline-danger p-20 m-0" @click="selectedTab('option3')">Windy 레이더</div>
                                </div>
                            </div>

                            <input type="radio" id="option1" value="option1" v-model="selectedTemp" style="display: none;">
                            <input type="radio" id="option2" value="option2" v-model="selectedTemp" style="display: none;">
                            <input type="radio" id="option3" value="option3" v-model="selectedTemp" style="display: none;">
                            
                            <Weather v-if="selectedTemp === 'option1'"></Weather>
                            <Imoc v-if="selectedTemp === 'option2'"></Imoc>
                            <Windy v-if="selectedTemp === 'option3'"></Windy>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
import Imoc from "./components/Imoc.vue";
import Weather from "./components/Weather.vue";
import Windy from "./components/Windy.vue";

export default {
    name: "weatherInfo",
    components: {
        Imoc,
        Weather,
        Windy
    },
    data() {
        return {
            selectedTemp: "option2"
        }
    },
    mounted() {
        console.log(this.weatherData);
    },
    methods: {
        selectedTab(value){
            this.selectedTemp = value;
        }
    }
};

</script>
<style>
.items-mid {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
}

.p-20{
    padding: 20px;
    border: 1px solid lightgray;
}
</style>
